import { Head, Link, router } from '@inertiajs/react'
import { useState, FormEvent } from 'react'
import { withWorkspaceLayout } from '@/app/layouts/WorkspaceLayout'
import { type PageNode } from '@/widgets/sidebar/PageTree'

interface SearchResult {
  id: number
  title: string
  slug: string
  path: string
  excerpt: string | null
}

interface SearchProps {
  workspace: { slug: string; name: string }
  query: string
  results: SearchResult[]
  sidebar_pages?: PageNode[]
}

function Search({ workspace, query, results }: SearchProps) {
  const [searchQuery, setSearchQuery] = useState(query)

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault()
    router.get(`/${workspace.slug}/search`, { q: searchQuery })
  }

  return (
    <>
      <Head title="Search" />
      <div className="mx-auto max-w-3xl px-4 py-8">
        <h1 className="mb-6 text-2xl font-bold text-gray-900">Search</h1>

        <form onSubmit={handleSubmit} className="mb-8">
          <div className="flex gap-2">
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Search pages..."
              className="flex-1 rounded-md border border-gray-300 px-4 py-2 focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500"
              autoFocus
            />
            <button
              type="submit"
              className="rounded-md bg-indigo-600 px-4 py-2 text-sm font-medium text-white hover:bg-indigo-700"
            >
              Search
            </button>
          </div>
        </form>

        {query && (
          <p className="mb-4 text-sm text-gray-500">
            {results.length} result{results.length !== 1 ? 's' : ''} for "{query}"
          </p>
        )}

        <div className="space-y-4">
          {results.map((result) => (
            <Link
              key={result.id}
              href={`/${workspace.slug}/${result.path}`}
              className="block rounded-lg border border-gray-200 p-4 hover:border-indigo-300 hover:bg-gray-50"
            >
              <h2 className="text-lg font-medium text-indigo-600">{result.title}</h2>
              {result.excerpt && (
                <p className="mt-1 text-sm text-gray-600">{result.excerpt}</p>
              )}
            </Link>
          ))}

          {query && results.length === 0 && (
            <p className="py-8 text-center text-gray-500">No pages found matching your search.</p>
          )}
        </div>
      </div>
    </>
  )
}

Search.layout = withWorkspaceLayout
export default Search
